import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouteGuard } from '../routing-guard';
import { SigningSummaryComponent } from '../shared/installation-report-content-v2/v2-components/plot-design-v2/signing-summary/signing-summary.component';
import { GroupAgreementDetailsWrapperComponent } from './group-agreement-details-page/group-agreement-details-wrapper/group-agreement-details-wrapper.component';
import { mduEnabledGuard } from './helpers/mdu-enabled.guard';
import { InstallationReportModalV2Component } from './installation-reporting-wrapper/installation-report-modal-v2/installation-report-modal-v2.component';
import { InstallationReportingWrapperComponent } from './installation-reporting-wrapper/installation-reporting-wrapper.component';

const routes: Routes = [
  {
    path: ':ifs/:groupAgreementId/:sourceId/sign',
    component: SigningSummaryComponent,
    canActivate: [RouteGuard, mduEnabledGuard],
  },
  {
    path: ':ifs/:deliveryOrderId/sign',
    component: SigningSummaryComponent,
    canActivate: [RouteGuard],
  },
  {
    path: ':ifs/reports',
    component: GroupAgreementDetailsWrapperComponent,
    canActivate: [RouteGuard, mduEnabledGuard],
  },
  {
    path: ':ifs',
    component: InstallationReportingWrapperComponent,
    canActivate: [RouteGuard],
    children: [
      {
        path: ':deliveryOrderId',
        component: InstallationReportModalV2Component,
        canActivate: [RouteGuard],
      },
    ],
  },
  {
    path: '',
    component: InstallationReportingWrapperComponent,
    canActivate: [RouteGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InstallationReportingAppRouterModule {}
